const AIEmailView = ({ email }) => {
  return (
    <div className="custom-scrollbar flex h-full max-h-[60vh] min-h-[300px] w-full flex-col overflow-y-auto rounded-xl border border-zinc-700/60 bg-zinc-800/40 p-4 sm:p-5">
      {/* Header */}
      <div className="mb-3 flex items-center">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-zinc-400">
          AI Summary
        </h2>
      </div>

      {/* Summary Content */}
      <p className="mb-4 text-xs leading-relaxed text-zinc-200">
        {email?.summary || 'No AI summary available for this email.'}
      </p>

      {/* Action Items */}
      {email?.actionItems?.length > 0 && (
        <div className="border-t border-zinc-700/50 pt-3">
          <h3 className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-zinc-400">
            ⚡ Action Items
          </h3>
          <div className="flex flex-wrap gap-2">
            {email.actionItems.map((action, index) => (
              <span
                key={index}
                className="inline-flex items-center rounded-lg border border-zinc-700 bg-zinc-800/80 px-2.5 py-1 text-xs text-zinc-200"
              >
                {action?.task}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AIEmailView;
